import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Icon } from "@iconify/react/dist/iconify.js";
import { ZOOM_CALLS_LIST, ZOOM_CRON_URL } from "../../global/API";
import { Calendar } from "primereact/calendar";
import { PulseLoader } from "react-spinners";
import { format } from "date-fns";

const ZoomCalls = () => {
  const [zoomList, setZoomList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [changeType, setChangeType] = useState("");
  const [selectedZoomCalls, setSelectedZoomCalls] = useState([]);
  const [dates, setDates] = useState({ from: null, to: null });
  const [paginationObj, setPaginationObj] = useState({ pageSize: 50, current: 1 });
  const [filteredValues, setFilteredValues] = useState({ searchValue: "" });

  const onHandleselectedList = (id, event) => {
    const newList = id;
    if (event.target.checked) {
      setSelectedZoomCalls((preState) => [...preState, newList]);
    } else {
      const filteredListing = selectedZoomCalls.filter((item) => item !== id);
      setSelectedZoomCalls(filteredListing);
    }
  };

  const fetchData = async (current, pageSize = paginationObj.pageSize) => {
    const { searchValue } = filteredValues;
    setIsLoading(true);
    const jwtToken = Cookies.get("jwtToken");

    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };

    let zoomQuery = `?limit=${pageSize}&page=${current}`;

    if (filteredValues.searchValue) {
      zoomQuery += `${searchValue ? `&search=${searchValue}` : ""}`;
      // &search=${filteredValues.searchValue}
    }
    if (dates?.[0]) {
      zoomQuery += `&fdate=${format(new Date(dates[0]), "yyyy-MM-dd")}`;
    }
    if (dates?.[1]) {
      zoomQuery += `&tdate=${format(new Date(dates[1]), "yyyy-MM-dd")}`;
    }

    const URL = ZOOM_CALLS_LIST + zoomQuery;
    try {
      const response = await fetch(URL, options);
      if (response.ok) {
        const data = await response.json();
        setZoomList(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const zoomCron = async () => {
    const jwtToken = Cookies.get("jwtToken");

    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };
    const URL = ZOOM_CRON_URL;
    try {
      const response = await fetch(URL, options);
      if (response.ok) {
        const data = await response.json();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    zoomCron();
  }, []);

  useEffect(() => {
    fetchData(paginationObj.current, paginationObj.pageSize);
  }, [paginationObj]);

  useEffect(() => {
    const { searchValue } = filteredValues;
    if (searchValue?.length >= 3 || searchValue === "") {
      const timeout = setTimeout(() => {
        fetchData(1, paginationObj.pageSize);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [filteredValues.searchValue, dates]);

  useEffect(() => {
    if (changeType !== "" || dates) {
      fetchData(1, paginationObj.pageSize);
    }
  }, [changeType, dates]);

  const filterGrid = (e) => {
    const { name, value } = e.target;
    setFilteredValues({
      ...filteredValues,
      [name]: value,
    });
  };

  const paginationChange = (current, pageSize) => {
    setPaginationObj({ ...paginationObj, current });
    fetchData(current, pageSize);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const zoomListView = () => {
    return zoomList.data.map((leads) => {
      // const { id, Contact_Name, Contact_Created_Date, Primary_Email_Address, Entity, Primary_Address_City, Primary_Address_Country, Primary_Address_Street, Primary_Phone_Number } = leads;
      const { id, direction, from_name, to_name, start_time, from_phone_number, to_ext, to_phone_number, from_ext, event, call_result, recorded, duration, site, created_date } = leads;

      const formatDate = (dateString) => {
        let isoString;
        if (dateString?.includes("T")) {
          isoString = dateString;
        } else {
          isoString = dateString.replace(" ", "T") + "Z";
        }

        const date = new Date(isoString);

        return new Intl.DateTimeFormat("en-US", {
          year: "numeric",
          month: "short", // Jan, Feb
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false, // <-- AM/PM
          timeZone: "UTC", // <-- change to EST or any timezone
        }).format(date);
      };

      // const date = new Date(start_time);
      // const formatted = date.toLocaleString("en-US", {
      //   year: "numeric",
      //   month: "short",
      //   day: "2-digit",
      //   hour: "2-digit",
      //   minute: "2-digit",
      //   second: "2-digit",
      //   hour12: false,
      //   timeZone: "UTC", // <-- force UTC if needed
      // });
      function formatUSPhoneNumber(number) {
        const cleaned = ("" + number).replace(/\D/g, ""); // Remove non-digits
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

        if (match) {
          return `(${match[1]}) ${match[2]} ${match[3]}`;
        }

        return number; // Return original if not a valid 10-digit number
      }
      return (
        <tr key={id}>
          <td>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" onChange={(e) => onHandleselectedList(id, e)} checked={selectedZoomCalls.includes(id)} />
              <label className="form-check-label"></label>
            </div>
          </td>
          <td className="capitalize">
            {from_name ? <a className="clio-name">{from_name.toLowerCase()}</a> : "--"} <br></br>
            {from_phone_number ? (
              <>
                <a href={`tel:+1${from_phone_number}`}>{formatUSPhoneNumber(from_phone_number)}</a>&nbsp;&nbsp;
              </>
            ) : (
              ""
            )}
            {from_ext ? <>Ext {from_ext}</> : ""}
          </td>
          <td>
            <a className="clio-name">{to_name}</a>
            <br></br>
            {to_phone_number ? (
              <>
                {" "}
                <a href={`tel:+1${to_phone_number}`}>{formatUSPhoneNumber(to_phone_number)}</a>&nbsp;&nbsp;
              </>
            ) : (
              ""
            )}
            {to_ext ? <>Ext {to_ext}</> : ""}
          </td>
          <td>{start_time !== null ? formatDate(start_time) : "--"}</td>
          {/* <td>{event ? event : "--"}</td> */}
          <td>{call_result}</td>
          {/* <td>{recorded}</td> */}
          <td>{duration}</td>
          <td>{direction}</td>
          {/* <td>{site}</td> */}
        </tr>
      );
    });
  };

  const leadsLoadingView = () => {
    return (
      <tr className="loading-hover">
        <td className="property-loader preloader">
          <PulseLoader color="#4180ad" />
        </td>
      </tr>
    );
  };

  const noLeadsView = () => {
    return (
      <tr className="loading-hover">
        <td className="no-data-found">
          <a className="fs-28 avatar-title" style={{ lineHeight: "20px", marginBottom: "8px" }}>
            <i className="ri-file-warning-line"></i>
          </a>
          No Zoom Call Data Found
        </td>
      </tr>
    );
  };

  const renderView = () => {
    if (isLoading) {
      return leadsLoadingView();
    } else if (zoomList.status === "Not Found") {
      return noLeadsView();
    } else if (zoomList.status === "Success") {
      return zoomListView();
    }
  };

  return (
    <div className="page-content leads-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0">
                Zoom Calls <span>({zoomList.pagination !== undefined ? zoomList.pagination.total : 0})</span>
              </h4>

              <div className="page-title-box-content">
                {selectedZoomCalls.length > 0 && (
                  <button type="button" className="page-title-btn custom-target-icon fs-18" data-pr-position="bottom" data-pr-tooltip="Delete">
                    <i className="ri-delete-bin-line"></i>
                  </button>
                )}
                <button
                  type="button"
                  className="page-title-btn refresh-button"
                  title="Reset"
                  onClick={() => {
                    setFilteredValues({ searchValue: "" });
                    setChangeType(0);
                    setDates({ from: null, to: null });
                  }}
                >
                  <i className="ri-refresh-line"></i>
                </button>
                <Calendar
                  value={dates}
                  onChange={(e) => setDates(e.value)}
                  selectionMode="range"
                  readOnlyInput
                  hideOnRangeSelection
                  placeholder="Date Range"
                  dateFormat="M dd yy"
                  showButtonBar
                  showIcon
                />

                <form className="app-search">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control border-0"
                      placeholder="Search..."
                      autoComplete="off"
                      value={filteredValues.searchValue || ""}
                      onChange={filterGrid}
                      name="searchValue"
                    />
                    <i className="ri-search-line search-widget-icon"></i>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table align-middle text-nowrap table-hover table-centered property-table">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th style={{ width: "10px", paddingRight: "0" }}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedZoomCalls(zoomList.data.map((lead) => lead.id));
                              } else {
                                setSelectedZoomCalls([]);
                              }
                            }}
                            checked={zoomList?.data?.length > 0 && selectedZoomCalls.length === zoomList.data.length}
                          />
                          <label className="form-check-label"></label>
                        </div>
                      </th>
                      <th>From</th>
                      <th>To</th>
                      <th>Start Time</th>
                      {/* <th>Event</th> */}
                      <th>Call Result</th>
                      {/* <th>Recorded</th> */}
                      <th>Duration</th>
                      <th>Direction</th>
                      {/* <th>Site</th> */}
                    </tr>
                  </thead>
                  <tbody>{renderView()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="pagination-grid">
          <div className="pagination-new">
            <span className="pagination-count">
              {zoomList.pagination !== undefined ? zoomList.pagination.from : 1}-{zoomList.pagination !== undefined ? zoomList.pagination.to : 50} &nbsp;of &nbsp;
              {zoomList.pagination !== undefined ? zoomList.pagination.total : 0}
            </span>

            <button
              type="button"
              className="pagination-btn pagination-prev"
              onClick={() => {
                setPaginationObj((prevState) => ({ ...prevState, current: prevState.current - 1 }));
              }}
              disabled={paginationObj.current === 1}
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button
              type="button"
              className="pagination-btn pagination-next"
              onClick={() => {
                setPaginationObj((prevState) => ({ ...prevState, current: prevState.current + 1 }));
              }}
              disabled={paginationObj.current === zoomList?.pagination?.last_page}
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZoomCalls;
